import { FaInstagram, FaYoutube } from "react-icons/fa";
import { useTranslation } from "react-i18next";

const DownloadButton = () => {
  const { t } = useTranslation();
  return (
    <div id="title__download">
        <br />
        <span id="title__span">
          <a href="https://apps.apple.com/kr/app/spettrum-%EC%8A%A4%ED%8E%AB%ED%8A%B8%EB%9F%BC-ai-%EC%98%A8%EB%9D%BC%EC%9D%B8-%EB%B0%98%EB%A0%A4%EB%8F%99%EB%AC%BC-%EC%8A%A4%ED%8A%9C%EB%94%94%EC%98%A4/id6468774776">
              <img id="title__download_img" src={t("AniTitleImg_1")} />
          </a>
        </span>
        <span id="title__span" style={{ paddingLeft: "60px" }}>
            <a href="https://play.google.com/store/apps/details?id=com.spettrum">
              <img id="title__download_img" src={t("AniTitleImg_2")} />
            </a>
        </span>
        <br />
        <br />
        <span id="title__span">
            <a href={t("IR_Deck_Link")}>
                <img id="title__download_img" src={t("AniTitleImg_3")} />
            </a>
        </span>
    </div>
  );
};
export default DownloadButton;
